import moment from "moment-timezone";
import { useMemo } from "react";

export const useSortTimeSheets = (data) => {
    return useMemo(() => {
        const isUnit = (item) => item.hourType === "unit";
        const isAmount = (item) => item.hourType === "amount";

        return data?.sort((a, b) => {

            const aIsSpecial = isUnit(a) || isAmount(a);
            const bIsSpecial = isUnit(b) || isAmount(b);

            if (aIsSpecial && !bIsSpecial) return 1;
            if (!aIsSpecial && bIsSpecial) return -1;

            const startDiff = moment(a.startDate).diff(moment(b.startDate));
            if (startDiff !== 0) return startDiff;

            return moment(a.endDate).diff(moment(b.endDate));
        });

    }, [data]);
};

export const useSortRetros = (data) => {
    const deletedTimesheets = data?.filter((item) =>
        Number(item?.duraton || 0) < 0
        || Number(item?.otherDuration || 0) < 0
        || Number(item?.total || 0) < 0
    );

    const deletedTimesheetIds = deletedTimesheets?.map((item) => item?.id);

    const timesheets = data?.filter((item) => !deletedTimesheetIds.includes(item?.id));

    return [
        ...useSortTimeSheets(deletedTimesheets || []),
        ...useSortTimeSheets(timesheets || [])
    ]
};